import React from 'react';
import { Box } from '@heycater/design-system';

import * as Questions from 'qualification/components/question_types';
import BudgetQuestionWithPeopleCount from 'qualification/components/question_types/BudgetQuestionWithPeopleCount';
import DatePickerQF from 'qualification/components/question_types/DatePicker/DatePickerQF';
import { Step } from 'qualification/schema/model';
import { cateringCategoriesQuestion } from 'qualification/schema/questions/cateringCategoriesQuestion';
import { cityQuestion } from 'qualification/schema/questions/cityQuestion';
import {
  customerTierQuestion,
  rareCustomerTierQuestion,
} from 'qualification/schema/questions/customerTierQuestion';
import CustomerTier from 'shared/components/EmbeddedFunnel/experiments/customer_tier/CustomerTier';
import CustomerRareTier from 'shared/components/EmbeddedFunnel/experiments/rare_tier/CustomerRareTier';

interface Props {
  step: Step;
  hasSidebar?: boolean;
}

const QuestionFactory: React.FC<Props> = ({ step, hasSidebar }) => {
  switch (step.id) {
    case 'city':
      return (
        <Questions.CardSelect
          question={cityQuestion}
          orientation="horizontal"
          displayOptions={10}
        />
      );
    case 'catering_categories':
      return (
        <Questions.CardSelect
          question={cateringCategoriesQuestion}
          multi
          orientation="horizontal"
          displayOptions={6}
        />
      );
    case 'event_date':
      return <DatePickerQF hasSidebar={hasSidebar} />;
    case 'people_count_and_budget':
      return (
        <Box py={5} mt={3}>
          <BudgetQuestionWithPeopleCount />
        </Box>
      );
    case 'dietary_restrictions':
      return <Questions.DietaryDistribution />;
    case customerTierQuestion.id:
      return (
        <Box my={4}>
          <CustomerTier />
        </Box>
      );
    case rareCustomerTierQuestion.id:
      return (
        <Box my={4}>
          <CustomerRareTier />
        </Box>
      );
    default:
      return null;
  }
};

export default QuestionFactory;
